import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentBase } from 'src/app/_utils/component.base';

@Component({
  selector: 'app-card-module',
  templateUrl: './card-module.component.html',
  styleUrls: ['./card-module.component.scss'],
})
export class CardModuleComponent extends ComponentBase {

  @Input() public title;
  @Input() public description;
  @Input() public image;
  @Input() public percentage;
  @Input() public route;
  @Input() public visible;
  @Input() public module;

  constructor(
    public router: Router,
  ) {
    super();
  }

  protected navigateToModule = async () => {
    return this.navigateRoute(this.route);
  };

  private navigateRoute(route: string) {
    this.router.navigate([route]);
  }
}
